module.exports = __webpack_public_path__ + "img/21_25_bg.d40a6812.png";